<template>
  <div class="home-container">
    <!-- 页面头部 -->

    <!-- 活动主体内容 -->
    <main class="main-content">
      <!-- 标题区域 -->
      <div class="title-section">
        <div class="title-wrapper">
          <i class="fas fa-times close-btn" @click="closeWebView"></i>
          <h1 class="main-title">墨 客 争 霸</h1>
        </div>
        <p class="subtitle">书法知识答题竞赛</p>
      </div>

      <!-- 活动规则说明 -->
      <div class="rules-section">
        <h2 class="section-title">
          <i class="fas fa-list-ol"></i>
          活动规则
        </h2>
        <ul class="rules-list">
          <li class="rule-item">
            <span class="rule-number">1</span>
            <p>在限定时间内答题，答对越多，排名越靠前。</p>
          </li>
          <li class="rule-item">
            <span class="rule-number">2</span>
            <p>题目都是跟书法相关的内容，均为单选题。</p>
          </li>
        </ul>
      </div>

      <!-- 时间选择区域 -->
      <div class="time-selection">
        <h2 class="section-title">
          <i class="fas fa-clock"></i>
          选择答题时间
        </h2>
        <div class="time-buttons">
          <button 
            v-for="time in timeOptions" 
            :key="time.value"
            class="time-btn"
            :class="{ active: selectedTime === time.value }"
            @click="selectTime(time.value)"
          >
            <i class="fas fa-hourglass-half"></i>
            <span>{{ time.label }}</span>
          </button>
        </div>
      </div>

      <!-- 开始挑战按钮 -->
      <div class="start-section">
        <button class="start-btn" @click="startChallenge">
          <i class="fas fa-flag-checkered"></i>
          开始挑战
        </button>
      </div>

      <!-- 底部功能按钮 -->
      <div class="bottom-buttons">
        <button class="bottom-btn" @click="handleRanking">
          <i class="fas fa-trophy"></i>
          <span>排行榜</span>
        </button>
        <button class="bottom-btn" @click="handleRecords">
          <i class="fas fa-chart-column"></i>
          <span>我的记录</span>
        </button>
      </div>
    </main>
  </div>
</template>

<script>
import { globalAuthState, initAuthState } from '../utils/auth';
export default {
  name: 'HomePage',
  data() {
    return {
      showBack: false,
      showRecordsIcon: true,
      selectedTime: 5,
      timeOptions: [
        { value: 5, label: '5分钟' },
        { value: 10, label: '10分钟' },
        { value: 15, label: '15分钟' }
      ]
    }
  },
  methods: {
    index() {
      
    },
    selectTime(time) {
      this.selectedTime = time
    },
    async startChallenge() {
      // 检查是否有用户信息，强制刷新登录状态
      await initAuthState();
      
      if (!globalAuthState.isLogin) {
        // 没有用户信息，跳转到登录页面
        this.$router.push('/login')
      } else {
        // 有用户信息，正常跳转到答题页面
        this.$router.push({
          path: '/quiz',
          query: { time: this.selectedTime }
        })
      }
    },
    closeWebView() {
      // 调用JSBridge关闭网页
      if (window.jsBridge) {
        window.jsBridge.closeWebView();
      } else {
        // 浏览器环境下，直接关闭当前页面
        window.close();
      }
    },
    handleBack() {
      // 返回上一页或主页
      if (window.history.length > 1) {
        this.$router.go(-1)
      } else {
        this.$router.push('/')
      }
    },
    handleRanking() {
      this.$router.push('/ranking')
    },
    handleRecords() {
      this.$router.push('/records')
    }
  },
  async created() {
    // 初始化登录状态
    await initAuthState();
    this.index()
  }
}
</script>

<style scoped>
.home-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, #f5f5f5 0%, #e8e8e8 100%);
  font-family: 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
  color: #1A1A1A;
  position: relative;
}



/* 头部样式 */
.header {
  display: flex;
  align-items: flex-end;
  color: #fff;
  padding: 15px;
  font-size: 18px;
}

.header-left, .header-right {
  width: 50px;
}

.header-center {
  flex: 1;
  text-align: center;
}

.header-title {
  font-size: 18px;
  color: #000;
  margin: 0;
}

.back-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 18px;
  color: #666;
  transition: color 0.3s;
}

.back-btn:hover {
  color: #D54D24;
}

/* 主要内容样式 */
.main-content {
  flex: 1;
  padding: 20px;
  z-index: 1;
}

.title-section {
  text-align: center;
  margin-bottom: 15px;
  padding: 20px 0;
}

.title-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-bottom: 16px;
}

.close-btn {
  position: absolute;
  left: 0;
  font-size: 24px;
  color: #333;
  cursor: pointer;
  transition: color 0.3s;
}

.close-btn:hover {
  color: #D54D24;
}

.main-title {
  color: #D54D24;
  margin: 0 0 12px 0;
  text-shadow: 2px 2px 4px rgba(213, 77, 36, 0.2);
  letter-spacing: 8px;
}

.subtitle {
  color: #999999;
  font-size: 16px;
  margin: 16px 0 16px 0;
  font-weight: 500;
  letter-spacing: 12px;
  line-height: 1.8;
}

/* 规则区域 */
.rules-section {
  background: white;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
}

.rules-section:hover {
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 20px;
  font-weight: bold;
  color: #333333;
  margin: 0 0 20px 0;
}

.rules-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.rule-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.rule-number {
  background: #D54D24;
  color: white;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  flex-shrink: 0;
  margin-top: 2px;
}

.rule-item p {
  margin: 0;
  color: #666666;
  font-size: 16px;
  line-height: 1.6;
}

/* 时间选择区域 */
.time-selection {
  margin-bottom: 32px;
}

.time-buttons {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}

.time-btn {
  flex: 1;
  padding: 20px 12px;
  border: none;
  border-radius: 12px;
  background: #999999;
  color: white;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  font-weight: bold;
}

.time-btn:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.time-btn.active {
  background: #D54D24;
  box-shadow: 0 6px 16px rgba(213, 77, 36, 0.3);
}

.time-btn i {
  font-size: 24px;
}

.time-btn span {
  font-size: 16px;
}

/* 开始挑战按钮 */
.start-section {
  margin-bottom: 32px;
}

.start-btn {
  width: 100%;
  padding: 20px;
  border: none;
  border-radius: 12px;
  background: #D54D24;
  color: white;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  box-shadow: 0 6px 12px rgba(213, 77, 36, 0.3);
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.start-btn:hover {
  background: rgba(213, 77, 36, 0.9);
  box-shadow: 0 8px 20px rgba(213, 77, 36, 0.4);
  transform: translateY(-2px);
}

/* 底部功能按钮 */
.bottom-buttons {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}

.bottom-btn {
  flex: 1;
  padding: 16px;
  border: none;
  border-radius: 12px;
  background: white;
  color: #666666;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.bottom-btn:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.bottom-btn i {
  font-size: 18px;
}

.bottom-btn:first-child i {
  color: #FFD700;
}

.bottom-btn:last-child i {
  color: #D54D24;
}

/* 模态框样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
}

.modal-content {
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 25px rgba(0, 0, 0, 0.25);
  width: 100%;
  max-width: 400px;
  margin: 0 20px;
}

.modal-body {
  padding: 24px;
}

.modal-title {
  font-size: 20px;
  font-weight: bold;
  color: #333333;
  text-align: center;
  margin: 0 0 16px 0;
}

.modal-message {
  color: #999999;
  text-align: center;
  margin: 0 0 24px 0;
  font-size: 14px;
  line-height: 1.5;
}

.modal-buttons {
  display: flex;
  justify-content: center;
  gap: 16px;
}

.cancel-btn, .confirm-btn {
  padding: 8px 24px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
}

.cancel-btn {
  background: #999999;
  color: white;
}

.cancel-btn:hover {
  background: rgba(153, 153, 153, 0.8);
}

.confirm-btn {
  background: #D54D24;
  color: white;
}

.confirm-btn:hover {
  background: rgba(213, 77, 36, 0.9);
}
</style>